import { collection, getDocs, query, limit } from 'firebase/firestore';
import { db } from '../config/firebase';
import { initializeCardTemplatesFromJson } from './cardTemplatesService';
import deploymentCards from '../mocks/deploymentCards.json';

/**
 * Check and initialize card templates
 * Creates templates from mock JSON file if none exist in Firebase
 * @returns {Promise<boolean>} Success status of the initialization
 */
export const initializeCardTemplatesIfNeeded = async () => {
  try {
    console.log('Checking if card templates need to be initialized...');
    
    // Check if templates already exist in Firebase
    const templatesCollection = collection(db, 'cardTemplates');
    const templatesQuery = query(templatesCollection, limit(1));
    const querySnapshot = await getDocs(templatesQuery);
    
    // If no templates exist, initialize from mock data
    if (querySnapshot.empty) {
      console.log('No card templates found, initializing from mock data...');
      await initializeCardTemplatesFromJson(deploymentCards);
      console.log('Card templates initialized successfully');
      return true;
    } else {
      console.log('Card templates already exist, no initialization needed');
      return false;
    }
  } catch (error) {
    console.error('Error initializing card templates:', error);
    return false;
  }
};

export default initializeCardTemplatesIfNeeded; 